export default __webpack_public_path__ + "static/media/kit_6.82e91ee0.png";